import React from 'react'
import ChatMessage from 'src/components/ChatMessage'
import { formatDate } from './helpers'

const ThreadMessage = ({ message, rankedJobs }) => (
  <ChatMessage
    role={message.role}
    content={message.content}
    createdAt={formatDate(message.createdAt)}
    feedback={message.feedback}
    rankedJobs={rankedJobs}
  />
)

export default ThreadMessage
